import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { LibraryElement } from './LibraryElement';
import { NodeLibraryNodeItem } from './NodeLibraryNodeItem';

interface Props {
    categoryName: string;
    categoryColor: string;
    nodes: LibraryElement[];
    selectedElement: LibraryElement | undefined;
    isOpen: boolean;
    onToggle: () => void;
    onElementHover: (element: LibraryElement) => void;
    onElementClick: () => void;
    scrollSelectedIntoView?: boolean;
}

export const NodeLibraryCategoryItem: React.FC<Props> = ({
    categoryName,
    categoryColor,
    nodes,
    selectedElement,
    isOpen,
    onToggle,
    onElementHover,
    onElementClick,
    scrollSelectedIntoView,
}) => {
    return (
        <Collapsible open={isOpen} onOpenChange={onToggle} style={{ borderLeft: `3px solid ${categoryColor}99` }}>
            <CollapsibleTrigger
                className="flex w-full items-center gap-2 px-3 py-2 text-sm font-semibold text-foreground/80 hover:text-foreground transition-colors"
                style={{ backgroundColor: `${categoryColor}25` }}
            >
                <ChevronRight className={cn('h-3.5 w-3.5 shrink-0 transition-transform duration-200', isOpen && 'rotate-90')} />
                <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ backgroundColor: categoryColor }} />
                {categoryName}
            </CollapsibleTrigger>
            <CollapsibleContent>
                {nodes.map(element => (
                    <NodeLibraryNodeItem
                        key={element.id}
                        element={element}
                        selected={element === selectedElement}
                        onHover={() => onElementHover(element)}
                        onClick={onElementClick}
                        scrollIntoView={scrollSelectedIntoView}
                    />
                ))}
            </CollapsibleContent>
        </Collapsible>
    );
};
